import {useState} from "react";
import {FaAlignLeft} from "react-icons/fa6";

import Button from "@/components/button/Button.tsx";
import {ActionDialog} from "@/components/overlay/ActionDialog.tsx";
import {TooltipIconRA} from "@/components/overlay/TooltipIconRA.tsx";
import {RequestsWaterfall} from "@/components/transaction/RequestsWaterfall.tsx";
import {TxnNetworkResult} from "@/lib/types/transaction.ts";

interface WaterfallIconProps {
  step: number;
  requests: TxnNetworkResult[];
}

export const StepRequestsWaterfallModal = ({requests, step}: WaterfallIconProps) => {
  const [showModal, setShowModal] = useState(false);
  if (requests.length < 1) return null;

  return (
    <>
      <ActionDialog
        onConfirm={() => setShowModal(false)}
        size="xl"
        title={`Requests Waterfall: Step ${step}`}
        show={showModal}
        confirmBtnText="OK"
        onCancel={() => setShowModal(false)}
        hasCancelButton={false}
      >
        <RequestsWaterfall requests={requests} />
      </ActionDialog>
      <Button
        variant="ghost"
        size="fitContent"
        onClick={() => {
          setShowModal(true);
        }}
      >
        <TooltipIconRA
          placement="bottom"
          className="cursor-pointer"
          title="Show requests waterfall"
          icon={FaAlignLeft}
          iconProps={{size: "kpi"}}
        />
      </Button>
    </>
  );
};
